import { FormBuilder, FormGroup } from '@angular/forms';
import { GroupSeriesDataDto } from '../dtos/group-series-data.dto';

export class GroupSeriesFormFactory {
  static createGroupSeriesForm(fb: FormBuilder, groupSeriesDataDto: GroupSeriesDataDto): FormGroup {
    return fb.group({
      hideTherapist: [groupSeriesDataDto.hideTherapist],
      hideInSchedule: [groupSeriesDataDto.hideInSchedule],
      descriptionRich: [groupSeriesDataDto.descriptionRich]
    });
  }
}
